module.exports = __webpack_public_path__ + "img/eye-active.10b37a98.svg";